import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";
import ImageSlider from "./ImageSlider";

const AboutDeveloper = () => {
  const { handleShowModal } = useGlobalContext();
  const images = [
    { url: "/images/greater-thane-rera1.webp", caption: "P51700048334" },
    { url: "/images/greater-thane-rera2.webp", caption: "P51700048335" },
    { url: "/images/greater-thane-rera3.webp", caption: "P51700048333" },
    { url: "/images/greater-thane-rera4.webp", caption: "P51700053095" },
    { url: "/images/greater-thane-rera5.webp", caption: "P51700053057" },
    { url: "/images/greater-thane-rera6.webp", caption: "P51700053096" },
    { url: "/images/greater-thane-rera7.webp", caption: "P51700053217" },
  ];

  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      {/* <div className="d-block pt-2 pb-1 text-center">
        <img
          src="images/dosti-logo.webp"
          width="auto"
          height="100%"
          loading="lazy"
          alt="dosti realty"
        />
      </div> */}
      <div className="row">
        <div className="col-md-8">
          <h1 class="d-block section-heading color-primary text-capitalize">
            About Developer
          </h1>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={handleShowModal}
          >
            Chat with us
          </button>
        </div>
      </div>

      <p>
        Dosti Realty has been a trusted name in real estate for over 40 years,
        delivering 117+ projects on time. Known for innovation, quality, and
        transparency, Dosti Realty continues to redefine urban living with
        world-class developments. Dosti Greater Thane is another step towards
        affordable luxury, offering residents the perfect blend of connectivity,
        amenities, and lifestyle.
      </p>

      {/* <div class="rera-numbers">
        <div class="rera-item">
          <img src="images/rera-P51900046369.webp" alt="rera qr" />
          <strong>P51900046369</strong>
        </div>
      </div> */}

      <ImageSlider images={images} />

      <span className="pro-rera text-center-mob">
        Dosti Greater Thane has been registered via MahaRERA registration number
        and is available on the website{" "}
        <a href="https://maharera.mahaonline.gov.in/">
          https://maharera.mahaonline.gov.in/
        </a>{" "}
        under registered projects.
      </span>

      <p></p>
      <button
        className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={handleShowModal}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
